import Brace from "backbone.brace";
import Menus from "../collections/report-meta-menus";
import MenuTitle from "./report-meta-menuTitle";

const Model = Brace.Model.extend({
  namedAttributes: {
    columns: Array,
    debug: Object,
    export: Object,
    filter: Array,
    groupBy: Array,
    groupBySelected: Array,
    groupableParameterName: String,
    legend: String,
    menu: Menus,
    menuTitle: MenuTitle,
    paramsSelected: Object,
  },
  defaults: {
    menu: [
      {
        value: "Overview...",
        url: {
          endpoint: "",
          data: null,
        },
      },
    ],
  },
});

export { Model as default };
